<template>
  <div class="mail-event-search pa-10">
    <title-page icon="mdi-email-multiple">
      {{ $t('mail-event.search-mail-events') }}
    </title-page>

    <mail-event-list />
  </div>
</template>

<script>
import MailEventList from "@/components/elements/MailEventList.vue";

export default {
  name: 'MailEventSearch',
  components: {
    MailEventList,
  },

  data() {
    return {
    }
  },

  mounted() {
    // Check permissions if needed
    // if(!this.currentUser.permissions.includes('MAIL_EVENT_READ')) {
    //   this.$router.replace({name: 'dashboard'})
    //   return
    // }
  },
}
</script>

<style lang="scss">
.mail-event-search {
  // Add any specific styles for the search page here
}
</style>